import { useCallback, useLayoutEffect, useRef } from 'react';
import type { RTableHandle } from '../RTable/RTable.props';
import { TabController } from '../../tabs/TabController';

/** Один якорь на таблицу во вкладке. Восстанавливаем только при маунте после загрузки строк. */
export function useTablePosition(tableId: string, ready: boolean) {
  const tableRef = useRef<RTableHandle>(null);
  // Сохраняем владельца, а не читаем activeKey во время ухода на другую вкладку.
  const tabKey = useRef(window.location.pathname).current;
  const tabs = TabController.getInstance();
  const restored = useRef(false);

  useLayoutEffect(() => {
    if (!ready || !tableRef.current) return;
    const table = tableRef.current;
    if (!restored.current) {
      const rowId = tabs.getTableCenteredRowId(tabKey, tableId);
      if (rowId === null || !table.scrollToRow(rowId)) table.scrollToTop();
      restored.current = true;
    }
    // После refresh строки могли смениться без scroll-события. Запоминаем
    // текущий центр, но больше не двигаем viewport до следующего маунта.
    tabs.setTableCenteredRowId(tabKey, tableId, table.getCenteredRowId());
  }, [ready, tabKey, tableId, tabs]);

  const onCenteredRowChange = useCallback(
    (rowId: string) => {
      // Пустой/loading DOM не должен затереть якорь до восстановления.
      if (ready && restored.current) tabs.setTableCenteredRowId(tabKey, tableId, rowId);
    },
    [ready, tabKey, tableId, tabs]
  );

  return { tableRef, onCenteredRowChange };
}
